import { updateTickerItems } from "@/mocks/home";

export default function UpdateTicker() {
  const loop = [...updateTickerItems, ...updateTickerItems];

  return (
    <div className="bg-primary-500 text-background-50">
      <div className="flex items-stretch">
        <div className="flex items-center gap-2 px-4 md:px-6 py-2.5 bg-primary-600 shrink-0">
          <i className="ri-pulse-line text-[15px]"></i>
          <span className="font-label text-sm tracking-[0.14em] whitespace-nowrap">
            更新条
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center hover:[animation-play-state:paused]">
            {loop.map((item, i) => (
              <span
                key={`${item}-${i}`}
                className="flex items-center gap-2 px-6 py-2.5 text-sm whitespace-nowrap"
              >
                <i className="ri-time-line text-[14px] opacity-70"></i>
                {item}
                <span className="ml-4 w-1 h-1 rounded-full bg-background-50/50"></span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}